"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseValueCollectionQuery_1 = require("./BaseValueCollectionQuery");
var TimeseriesQuery = /** @class */ (function (_super) {
    __extends(TimeseriesQuery, _super);
    function TimeseriesQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeseriesQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    TimeseriesQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityType = _a.entityType, entityConditional = _a.entityConditional, code = _a.code, codeQuery = _a.codeQuery, key = _a.key, keyQuery = _a.keyQuery, collectionItemConditional = _a.collectionItemConditional, collectionItemValueConditional = _a.collectionItemValueConditional, sort = _a.sort, index = _a.index, startIndex = _a.startIndex, endIndex = _a.endIndex, entityKey = _a.entityKey, entityIndex = _a.entityIndex, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ entityType: entityType,
            entityConditional: entityConditional,
            code: code,
            codeQuery: codeQuery,
            key: key,
            keyQuery: keyQuery,
            collectionItemConditional: collectionItemConditional,
            collectionItemValueConditional: collectionItemValueConditional,
            sort: sort,
            index: index,
            startIndex: startIndex,
            endIndex: endIndex,
            entityKey: entityKey,
            entityIndex: entityIndex }, (options.timeseries || {}));
    };
    TimeseriesQuery.prototype.getRawValue = function (executionOptions) {
        return this.getRawValueOrRootKey(executionOptions);
    };
    return TimeseriesQuery;
}(BaseValueCollectionQuery_1.BaseValueCollectionQuery));
exports.TimeseriesQuery = TimeseriesQuery;
//# sourceMappingURL=TimeseriesQuery.js.map